<template>
    <div class="flex flex-column align-items-center">
        <div v-if="!renderingError" class="flex flex-column align-items-center">
            <span v-if="isDemo" style="opacity: 0.6; font-size: var(--font-size-small); font-weight: var(--font-weight-thin);">CAPTCHA in demo for testing purposes</span>
            <div class="relative flex flex-row justify-content-center align-items-center" style="width: 300px; height: 65px;">
                <div class="absolute flex flex-row align-items-center justify-content-center" style="bottom: 4px; width: 300px; height: 65px; padding-right:3rem; border: 1px solid var(--button-disabled-color); background-color: var(--theme-color1);">
                    <LoadingSpinner style="transform: scale(0.5);"/>
                    <span style="font-size: var(--font-size-small);">Loading ReCAPTCHA...</span>
                </div>
                <div class="absolute">
                    <div :id="widgetId"/>
                </div>
                
            </div>
        </div>
        <div v-else style="font-size: var(--font-size-small); color: var(--mydanger-color); border: 1px solid var(--button-disabled-color); background-color: var(--theme-color1);" class="p-3 mb-3 flex flex-column text-center justify-content-center align-items-center">
            <span>You seem to be having network problems.</span>
            <span>The ReCAPTCHA has not been loaded (error: {{ renderingError }}).</span>
            <span class="mt-2">Please try again by <span @click="reloadPage" style="cursor: pointer; border-bottom: 1px solid var(--mydanger-color);">reloading this page</span>.</span>
        </div>
    </div>
</template>

<script setup>
// --- IMPORTS ---
import { ref, toRefs, onMounted, onBeforeUnmount, computed, watchEffect } from 'vue';
// vue
import LoadingSpinner from '@/components/Modules/LoadingSpinner.vue';
// Others
import { useStore } from 'vuex';
const store = useStore()

const isWebView = computed(() => store.state.applicationWebView.isWebView)

// --- PROPS ---
const props = defineProps({
    widgetId: String
})
const { widgetId } = toRefs(props)

// --- EMITS ---
const emit = defineEmits(['human-verified'])

// --- Theme info ---
const theme = computed(() => store.state.theme.theme)

// --- Widget rendering + Emit when human is verified ---
const isDemo = ref(false)
const isWidgetRendered = ref(false);
const renderingError = ref(null);
const renderTurnstileWidget = () => {
    if (window.turnstile) {
        if (!isWidgetRendered.value || renderingError.value) {
            window.turnstile.render(`#${widgetId.value}`, {
                sitekey: isDemo.value ? '1x00000000000000000000AA' : '0x4AAAAAAAkyxfHCgXUa7tSM',
                theme: theme.value.isDark ? 'dark' : 'light',
                callback: function (token) {
                    renderingError.value = null;
                    emit('human-verified', `${token}`)
                },
                'error-callback': function (error) {
                    renderingError.value = error;
                }
            });
            isWidgetRendered.value = true;
        }
    } else {
        renderingError.value = "0";
    }
    
}
onMounted(() => {
    loadTurnstileScript();
    renderTurnstileWidget();
});
onBeforeUnmount(() => {
    if (window.turnstile) {
        window.turnstile.remove(`#${widgetId.value}`);
        isWidgetRendered.value = false;
    }
})
function loadTurnstileScript() {
    return new Promise((resolve, reject) => {
      // If the script is already loaded, resolve immediately
      if (window.turnstile) {
        return resolve();
      }
      // Create the script element without async and defer
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      // Attach error handling if the script fails to load
      script.onerror = () => {
        console.error('Turnstile script failed to load. Check your internet connection or script URL.');
      };
      
      // When loaded, ensure that the turnstile object is available
      script.onload = () => {
        if (window.turnstile) {
          resolve();
        }
      };
      
      document.head.appendChild(script);
    });
  }

const reloadPage = () => {
    if (isWebView.value) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsReloadWebView) {
            window.webkit.messageHandlers.jsReloadWebView.postMessage(null);
        }
    } else {
        window.location.reload()
    }
    
}
</script>

<style>
</style>